import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  isAuthenticated: boolean;
  requiredRoles?: string[];
  userRoles?: string[];
  redirectTo?: string;
  component: React.ComponentType;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  isAuthenticated,
  requiredRoles = [],
  userRoles = [],
  redirectTo = "/login",
  component: Component,
}) => {
  const hasPermission = requiredRoles.length
    ? requiredRoles.some((role) => userRoles.includes(role))
    : true;

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!hasPermission) {
    return <Navigate to="/forbidden" replace />;
  }

  return <Component />;
};

export default ProtectedRoute;
